import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaProcedimento.vue?vue&type=template&id=0cab6be5&scoped=true"
import script from "./ModalSolicitacaoCirurgiaProcedimento.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaProcedimento.vue?vue&type=style&index=0&id=0cab6be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab6be5",
  null
  
)

export default component.exports